import { Array, Predicate, String } from 'effect'

/**
 * プロパティの値が入力済みかを判定する
 * - 真偽値はチェックを外した状態 (false) も入力済みとして扱う
 * @param value プロパティの値
 * @returns 入力済みなら true
 */
export const isPresentValue = (value: unknown): boolean => {
  if (Predicate.isString(value)) {
    return String.isNonEmpty(value)
  }
  if (Array.isArray(value)) {
    return Array.isReadonlyArrayNonEmpty(value)
  }
  return Predicate.isNotNullish(value)
}
